// extracted by mini-css-extract-plugin
export default {"search":"SearchBar_search__VvMWd","button":"SearchBar_button__TtMLs","input":"SearchBar_input__k09dk"};